module.exports = __webpack_public_path__ + "static/img/bg-pt.ab687d36.webp";